export default __webpack_public_path__ + "static/media/email.2324a728.svg";